var map = {
	"./de": 77853,
	"./de.js": 77853,
	"./el": 54691,
	"./el.js": 54691,
	"./en-gb": 56195,
	"./en-gb.js": 56195,
	"./es": 97650,
	"./es.js": 97650,
	"./it": 88383,
	"./it.js": 88383,
	"./ja": 23827,
	"./ja.js": 23827,
	"./ru": 82271,
	"./ru.js": 82271,
	"./sv": 41011,
	"./sv.js": 41011
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93831;